import { useTranslation } from "react-i18next";
import { UiPageLayoutProps } from "../../models/components/page-layout.model";
import { classNames } from "primereact/utils";

const UiPageLayout = (props: UiPageLayoutProps) => {
	const { t } = useTranslation("common");

	return (
		<div className={classNames("page-layout", props.className)}>
			{/* Left column */}
			<div className="page-layout__left-column">
				{props.title && <h1 className="page-layout__title">{t(props.title)}</h1>}
				{props.titleChildren ? props.titleChildren : <></>}

				{/* Transclude content */}
				{props.leftChildren ? (
					<div className="page-layout__left-children">{props.leftChildren}</div>
				) : (
					<></>
				)}
			</div>

			{/* Right column */}
			<div className="page-layout__right-column">
				{/* Transclude content */}
				{props.rightChildren ? (
					<div className="page-layout__right-children">{props.rightChildren}</div>
				) : (
					<></>
				)}
			</div>
		</div>
	);
};

export default UiPageLayout;
